import { useCallback } from "react";

const useCellUpdateHandler = (updateRecruit, triggerRecruitsRefetch) => {
  return useCallback(async (rowId, columnId, newValueFromHook) => {
    // Field Mapping
    let mappedField = columnId;
    const fieldMapping = {
      first_name: "firstName",
      last_name: "lastName",
      date_of_interview: "interviewAt",
      date_of_translate: "decryptionAt",
      date_of_offer: "employmentAt",
      date_of_fired: "dismissalAt",
      working_phone: "businessPhone",
      phone_number: "personalPhone",
      NDA_date: "acceptNDA",
      FB_IG: "fbMg",
      commentary: "comment",
    };
    
    if (fieldMapping[columnId]) {
      mappedField = fieldMapping[columnId];
    }

    // Value Processing
    let processedNewValue = newValueFromHook;
    if (columnId === "NDA_date") {
      processedNewValue = newValueFromHook === "Yes";
    }
    
    if (columnId.includes("date_of") && processedNewValue) {
      try {
        const dateObj = new Date(processedNewValue);
        if (!isNaN(dateObj.getTime())) {
          processedNewValue = dateObj.toISOString();
        }
      } catch (error) {
        console.warn("Date conversion error:", error);
      }
    }
    
    if (["company", "team", "department", "position"].includes(columnId)) {
      if (typeof processedNewValue === "object" && processedNewValue?.id) {
        const idFieldMapping = {
          company: "companyId", team: "teamId",
          department: "departmentId", position: "postId",
        };
        mappedField = idFieldMapping[columnId];
        processedNewValue = processedNewValue.id;
      } else if (typeof processedNewValue === "string" && !processedNewValue.trim()) {
        const idFieldMapping = {
          company: "companyId", team: "teamId",
          department: "departmentId", position: "postId",
        };
        mappedField = idFieldMapping[columnId];
        processedNewValue = null;
      }
    }

    const recruitData = { [mappedField]: processedNewValue };

    try {
      await updateRecruit(rowId, recruitData);
      triggerRecruitsRefetch();
    } catch (error) {
      console.error("Error updating recruit:", error);
      throw error;
    }
  }, [updateRecruit, triggerRecruitsRefetch]);
};

export default useCellUpdateHandler;